import React from 'react';
import { Navbar } from 'react-bootstrap';
import logo from '../../logo.svg';
import { connect } from 'react-redux';
import './customNavBar.scss';

const mapStateToProps = (state) => {
  return {
    firstName: state.pagesData.data.basicInformation ? state.pagesData.data.basicInformation.firstName : null,
    lastName: state.pagesData.data.basicInformation ? state.pagesData.data.basicInformation.lastName : null
  };
};

const CustomNavBar = (props) => {
  return (
    <Navbar className="header-bg justify-content-between custom-navBar">
      <Navbar.Brand className="header-title" href="#home">
        Referral Portal
          <span className="line"></span>
        <span className="consumer-label">
          Consumer: {props.lastName}, {props.firstName}
        </span>
      </Navbar.Brand>
      <Navbar.Brand></Navbar.Brand>
      <Navbar.Brand href="#home">
        <img
          src={logo}
          className="d-inline-block align-top"
          alt="React Bootstrap logo"
        />
      </Navbar.Brand>
    </Navbar>
  );
};

export default connect(mapStateToProps)(CustomNavBar);
